// Helpers de apresentação do dashboard de pipeline (Story 11.12).
// Rótulos de origem de lead (não havia record exportado — ORIGIN_OPTIONS vivia
// dentro do LeadForm) e formatação de valor/percentual pros widgets.
// Disciplina de timezone: nada de datas aqui; só moeda/percentual.

import type { CrmLeadOriginSchema } from '@control-center/shared';

/** Rótulo PT-BR de cada origem de lead (fonte única do dashboard de origem). */
export const LEAD_ORIGIN_LABELS: Record<CrmLeadOriginSchema, string> = {
  instagram: 'Instagram',
  whatsapp: 'WhatsApp',
  indicacao: 'Indicação',
  trafego_pago: 'Tráfego pago',
  site: 'Site',
  landing_page: 'Landing page',
  evento: 'Evento',
  prospeccao_ativa: 'Prospecção ativa',
  outro: 'Outro',
};

/** Formata número monetário (já convertido de string Decimal) em BRL. */
export function formatPipelineMoney(value: number): string {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  });
}

/** Formata percentual (ex: 42.5 → "42,5%"). null → "—". */
export function formatPct(value: number | null): string {
  if (value === null) return '—';
  return `${value.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;
}
